var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwoMen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.564,
    height: 123.57,
    viewBox: "0 0 170.564 123.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122552",
    "data-name": "Group 122552",
    transform: "translate(1846 -23947.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171735",
    "data-name": "Path 171735",
    d: "M51.284,731.189H10.246V719.465C1.515,717,.049,715.059.042,706.36.033,694.7-.076,683.043.1,671.388c.174-11.508,6.216-17.806,17.669-18.794,5.469-.471,11.051-.31,16.4-1.364,10.729-2.115,19-8.764,26.114-16.568,5.354-5.87,9.768-12.6,14.635-18.914,2.164-2.809,4.4-5.542,8.618-4.466,6.408,1.634,8.28,5.326,5.736,12.168A92.4,92.4,0,0,1,57.8,665.708c-4.66,3.518-6.21,7.184-6.1,12.879.315,15.977-.027,31.968-.133,47.954-.009,1.462-.176,2.923-.286,4.648",
    transform: "translate(-1846 23340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171736",
    "data-name": "Path 171736",
    d: "M98.764,621.944c4.842,5.445,9.528,11.282,14.805,16.524,9.1,9.042,20.164,13.516,33.16,13.884,18.972.537,23.864,5.964,23.835,25.077q-.021,14.482-.089,28.965c-.045,8.352-1.977,10.818-10.316,12.967v11.708H118.653c0-3.561.008-7.016,0-10.471-.039-15.149-.161-30.3-.064-45.445.021-3.279-1.129-5.287-3.562-7.555-7.762-7.238-15.082-14.949-22.568-22.483-2.131-2.145-2.227-4.12-.7-7.008,2.774-5.253,4.781-10.911,7.007-16.163",
    transform: "translate(-1846 23340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171737",
    "data-name": "Path 171737",
    d: "M139.536,607.649c10.64-.595,19.851,7.72,19.83,19.921-.018,10.524-9.992,18.6-20.677,18.051-10.653-.551-17.95-9.4-17.64-20.786.195-7.174,7.82-17.651,18.487-17.186",
    transform: "translate(-1846 23340)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171738",
    "data-name": "Path 171738",
    d: "M30.375,607.662a19,19,0,0,1,.153,38,19,19,0,1,1-.153-38",
    transform: "translate(-1846 23340)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoMen);
export default __webpack_public_path__ + "static/media/twoMen.cee9c6b7e6106b3c2006578962d310e7.svg";
export { ForwardRef as ReactComponent };